import script from "./AtusHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./AtusHeader.vue?vue&type=script&setup=true&lang=js"

import "./AtusHeader.vue?vue&type=style&index=0&id=c3b06014&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3b06014"]])

export default __exports__